var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DialogCard',{attrs:{"title":_vm.title,"actions":_vm.actions}},[_vm._v(" Vill du att vi nollställer kontaktbegäran? ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }